import { Container } from "reactstrap";
// import starIcon from "../../assets/images/icons/star.svg";
import mapIcon from "../../assets/images/icons/maps-and-flags.png";
import * as userAction from "../../actions/user-action-type";
import HeaderBanner from "../../components/banners/HeaderBanner";
import cx from "classnames";
import { useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-multi-lang";
import ReactPixel from "react-facebook-pixel";
import ContentLoader from "react-content-loader";
import "./style.scss";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const tempImage =
  "https://images.unsplash.com/photo-1624561500881-d97c12c521e1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1051&q=80";

function RenderBookCard(props) {
  const {
    package_name,
    arabic_name,
    url_slug,
    price,
    original_price,
    child_price,
    rating,
    img,
    destination_id,
    destinationData,
    offer_tag,
    offer_tag_text,
    redirect,
    redirect_url,
    description,
    short_description,
  } = props;
  const history = useHistory();
  const t = useTranslation();
  const [destName, setDestName] = useState("");

  useEffect(() => {
    for (var i = 0; i < destinationData?.length; i++) {
      if (destinationData[i]["id"] == destination_id) {
        setDestName(destinationData[i].name);
      }
    }
  }, [destinationData, destination_id]);

  // Get destination name directly for GTM
  const getDestinationName = () => {
    if (!destinationData) return "";
    const destination = destinationData.find((d) => d.id == destination_id);
    return destination ? destination.name : "";
  };

  const top = () => (
    <div className="top-content">
      <div>
        {destName ? (
          <p className="rating">
            <img src={mapIcon} alt="rating" />
            {destName}
            {/* {rating} */}
          </p>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );

  const bottom = () => (
    <div className="bottom-div">
      <div className="card-content-wrapper">
        {localStorage.getItem("user_language") == "en" ? (
          <h3 className="card-title">{package_name}</h3>
        ) : (
          <h3 className="card-title">{arabic_name}</h3>
        )}
        <div
          className="description-text"
          dangerouslySetInnerHTML={{
            __html:
              description ||
              short_description ||
              "Discover amazing experiences and create unforgettable memories at this destination. Book your adventure today!",
          }}
        />
        <button
          className="know-more-button"
          onClick={(e) => {
            e.stopPropagation();
            // Use the same click logic as the card
            if (window.dataLayer) {
              const packageTitle =
                localStorage.getItem("user_language") == "en"
                  ? package_name
                  : arabic_name;
              const packagePrice = price || child_price || "0";
              const destinationName = getDestinationName();

              window.dataLayer.push({
                event: "package_click",
                package_data: {
                  title: packageTitle || "",
                  price: packagePrice,
                  original_price: original_price || "0",
                  destination: destinationName,
                  url_slug: window.location.origin + "/p/" + (url_slug || ""),
                },
              });
            }
            if (redirect === "1") {
              // Convert full URL to relative path if same domain
              const url = redirect_url || "";
              if (url.includes("discovershurooq.ae")) {
                const relativePath = url.replace(/https?:\/\/[^\/]+/, "");
                history.push(relativePath);
              } else {
                window.location.href = url;
              }
            } else {
              history.push(`/p/${url_slug}`);
            }
          }}
        >
          {redirect === "1" ? "KNOW MORE" : "BOOK NOW"}
        </button>
      </div>
    </div>
  );
  const image =
    "https://api.discovershurooq.ae/cdn-cgi/image/width=900,height=500,quality=85,format=auto/files/" +
    img;
  return (
    <div className="activity-item">
      {offer_tag == 1 ? (
        <div className="ribbon ribbon-top-left">
          <span>{offer_tag_text}</span>
        </div>
      ) : null}
      <div
        className="activity-content"
        data-gtm-title={
          localStorage.getItem("user_language") == "en"
            ? package_name
            : arabic_name
        }
        data-gtm-price={price != "" ? price : child_price}
        data-gtm-original-price={original_price || ""}
        data-gtm-destination={destName}
        data-gtm-url-slug={url_slug}
        onClick={(e) => {
          // Push to dataLayer for GTM tracking
          if (window.dataLayer) {
            const packageTitle =
              localStorage.getItem("user_language") == "en"
                ? package_name
                : arabic_name;
            const packagePrice = price || child_price || "0";
            const destinationName = getDestinationName();

            window.dataLayer.push({
              event: "package_click",
              package_data: {
                title: packageTitle || "",
                price: packagePrice,
                original_price: original_price || "0",
                destination: destinationName,
                url_slug: window.location.origin + "/p/" + (url_slug || ""),
              },
            });

            console.log("GTM Push:", {
              event: "package_click",
              package_data: {
                title: packageTitle || "",
                price: packagePrice,
                original_price: original_price || "0",
                destination: destinationName,
                url_slug: window.location.origin + "/p/" + (url_slug || ""),
              },
            });
          }
          if (redirect === "1") {
            // Convert full URL to relative path if same domain
            const url = redirect_url || "";
            if (url.includes("discovershurooq.ae")) {
              const relativePath = url.replace(/https?:\/\/[^\/]+/, "");
              history.push(relativePath);
            } else {
              window.location.href = url;
            }
          } else {
            history.push(`/p/${url_slug}`);
          }
        }}
      >
        <div className="activity-image-wrapper">
          <LazyLoadImage
            className="activity-image"
            src={image}
            alt={package_name}
            effect="blur"
            placeholderSrc={`https://api.discovershurooq.ae/cdn-cgi/image/width=100,quality=50,format=auto/files/${img}`}
          />
        </div>
        <div className="activity-details">{bottom()}</div>
      </div>
    </div>
  );
}

function BookYourExperience(props) {
  const [loader, setLoader] = useState(true);
  const btns = [
    { active: "true", name: "All" },
    { active: "false", name: "Couples" },
    { active: "false", name: "Friends" },
    { active: "false", name: "Family" },
    { active: "false", name: "Kids" },
  ];
  const t = useTranslation();
  const history = useHistory();
  localStorage.setItem("pathname", history.location.pathname);
  const { url_slug } = props.match.params;

  const [tag, setTag] = useState("All");
  const [backImg, setBackImg] = useState(
    "../../../assets/images/backgrounds/head-banner.png"
  );
  const [destName, setDestName] = useState("");
  const [destDcp, setDestDcp] = useState("");
  const [destHoverDcp, setDestHoverDcp] = useState("");
  const {
    getdestPackages,
    getDestPackageStatus,
    homeData,
    getHomeData,
    destPackagesData,
    destinationVoucherData,
    getDestVouchers,
    destinationData,
    getDestinationData,
  } = props;

  console.log(destPackagesData);
  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });

    const data = new FormData();
    data.append("action", "packages");
    data.append("slug", url_slug);
    const voucherDta = new FormData();
    voucherDta.append("action", "listVoucherByDesitnation");
    voucherDta.append("slug", url_slug);

    const home_data = new FormData();
    home_data.append("action", "HomeData");

    const formData = new FormData();
    formData.append("action", "destinations");
    getDestinationData(formData);
    getHomeData(home_data);
    getdestPackages(data);
    getDestVouchers(voucherDta);
  }, []);

  for (var i = 0; i < destinationData?.length; i++) {
    if (destinationData[i]["url_slug"] == url_slug) {
      if (destinationData[i]["name"]) {
        document.title = destinationData[i]["name"];
        let randomNum_1 = 0;
        let randomNum_2 = 0;
        let randomNum_3 = 0;
        let contentID = "";
        if (destPackagesData?.length > 0) {
          for (var j = 0; j < destPackagesData?.length; j++) {
            if (j > 0) {
              contentID += ",";
            }
            contentID += `'p-${destPackagesData[j].url_slug}'`;
          }
        }
        ReactPixel.track("ViewContent", {
          content_name: `${destinationData[i]["name"]} - Destination`,
          content_category: "page",
          content_type: "product_group",
          content_ids: `[${contentID}]`,
        });
      }
    }
  }

  useEffect(() => {
    setTimeout(() => setLoader(false), 2000);

    for (var i = 0; i < destinationData?.length; i++) {
      if (destPackagesData?.length != 0) {
        if (destinationData[i]["id"] == destPackagesData[0]["destination_id"]) {
          setBackImg(
            `https://api.discovershurooq.ae/files/` +
              destinationData[i]["featured_image"]
          );
          setDestName(destinationData[i]["name"]);
          setDestDcp(destinationData[i]["description"]);
          setDestHoverDcp(destinationData[i]["hover_text"]);
        }
      }
    }
  }, [destPackagesData]);

  const renderLoader = () => (
    <div className="activities-list">
      {["", "", ""].map((data, index) => (
        <div key={"bookData" + index} className="activity-loader">
          <ContentLoader
            speed={2}
            viewBox="0 0 1200 300"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
          >
            <rect x="0" y="0" rx="8" ry="8" width="400" height="300" />
            <rect x="430" y="20" rx="4" ry="4" width="600" height="25" />
            <rect x="430" y="60" rx="3" ry="3" width="700" height="15" />
            <rect x="430" y="85" rx="3" ry="3" width="680" height="15" />
            <rect x="430" y="110" rx="3" ry="3" width="720" height="15" />
            <rect x="430" y="135" rx="3" ry="3" width="650" height="15" />
            <rect x="430" y="240" rx="6" ry="6" width="150" height="40" />
          </ContentLoader>
        </div>
      ))}
    </div>
  );

  const renderData = (tag) => (
    <div className="activities-list">
      {destPackagesData.length == 0 ? (
        <div style={{ justifyContent: "center", display: "flex" }}>
          <p>No Packages Found</p>
        </div>
      ) : null}
      {destPackagesData
        .sort((a, b) => {
          if (a.position === null && b.position === null) {
            return 0;
          }
          if (a.position === null) {
            return 1;
          }
          if (b.position === null) {
            return -1;
          }
          return Number(a.position) - Number(b.position);
        })
        .map((data, index) =>
          data.hide == "0" &&
          data.enable == "1" &&
          data.checkout?.includes("DiscoverShurooq") ? (
            tag != "All" && !data.tags.includes(tag) ? null : (
              <RenderBookCard key={"bookData" + index} {...data} destinationData={destinationData} />
            )
          ) : null
        )}
      {destPackagesData.filter(
        (data, index) =>
          data.hide == "0" &&
          data.enable == "1" &&
          data.checkout?.includes("DiscoverShurooq")
      ).length === 0 && (
        <h2 style={{ textAlign: "center", marginTop: "4rem" }}>
          Coming Soon ...
        </h2>
      )}
    </div>
  );

  const showTagData = (tagName) => {
    setTag(tagName);
  };
  return (
    <div>
      <HeaderBanner
        linkPage={[
          { type: "link", name: "Home", link: "/" },
          { name: "Book Your Experience" },
        ]}
        backgroundImage={backImg}
        destinationName={destName}
        destinationDescription={destDcp}
        destinationHoverDescription={destHoverDcp}
      />
      <section className="book-youre-experience-section">
        <Container>
          <h2 className="sec-title">Book Your Experience</h2>
          <div className="tab-box-btn">
            <div className="wrapper">
              {btns.map(({ active, name }, index) => (
                <button
                  kye={index}
                  className={cx({ active: active })}
                  onClick={(e) => showTagData(name)}
                >
                  {name}
                </button>
              ))}
            </div>
          </div>
          {loader ? renderLoader() : renderData(tag)}
        </Container>
      </section>
    </div>
  );
}
const mapStateToProps = ({
  user: {
    homeData,
    getDestPackageStatus,
    destPackagesData,
    destinationVoucherData,
    destinationData,
  },
}) => ({
  homeData,
  getDestPackageStatus,
  destPackagesData,
  destinationVoucherData,
  destinationData,
});

const mapDispatchToProps = {
  getdestPackages: userAction.getdestPackages,
  getHomeData: userAction.getHomeData,
  getDestVouchers: userAction.getDestVouchers,
  getDestinationData: userAction.getDestinationData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BookYourExperience));
